/**
 * Centralized config surface (S-32).
 *
 * All `REACT_APP_*` environment variables are read here once and re-exported
 * as a frozen object. Every other module should import from `src/config`
 * instead of touching `process.env.*` directly.
 *
 * IMPORTANT: every value below ships in the public JS bundle. Never put
 * secrets here — that is what HttpOnly cookies / backend endpoints are for.
 */

const required = (name, value) => {
  if (!value) {
    // Surface missing config loudly in dev; stay quiet in production to avoid
    // leaking the missing variable's name in shipped bundles.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[config] Missing env var: ${name}`);
    }
  }
  return value || "";
};

const config = Object.freeze({
  api: Object.freeze({
    base: required("REACT_APP_apiBaseUrl", process.env.REACT_APP_apiBaseUrl),
    solana: required("REACT_APP_apiBaseUrlSolana", process.env.REACT_APP_apiBaseUrlSolana),
    ai: required("REACT_APP_apiBaseUrlAI", process.env.REACT_APP_apiBaseUrlAI),
    geminiWS: required("REACT_APP_WS_GEMINI_URL", process.env.REACT_APP_WS_GEMINI_URL),
    adminWS: required("REACT_APP_WS_ADMIN_BACKEND_URL", process.env.REACT_APP_WS_ADMIN_BACKEND_URL),
  }),
  firebase: Object.freeze({
    apiKey: required("REACT_APP_ApiKey", process.env.REACT_APP_ApiKey),
    authDomain: required("REACT_APP_AuthDomain", process.env.REACT_APP_AuthDomain),
    projectId: required("REACT_APP_ProjectId", process.env.REACT_APP_ProjectId),
    storageBucket: required("REACT_APP_StorageBucket", process.env.REACT_APP_StorageBucket),
    messagingSenderId: required("REACT_APP_MessagingSenderId", process.env.REACT_APP_MessagingSenderId),
    appId: required("REACT_APP_AppId", process.env.REACT_APP_AppId),
  }),
  google: Object.freeze({
    clientId: required("REACT_APP_GoogleClientID", process.env.REACT_APP_GoogleClientID),
  }),
  recaptcha: Object.freeze({
    siteKey: required("REACT_APP_SITE_KEY", process.env.REACT_APP_SITE_KEY),
  }),
  stripe: Object.freeze({
    publishableKey: required("REACT_APP_STRIPE_PK", process.env.REACT_APP_STRIPE_PK),
  }),
  env: process.env.NODE_ENV || "development",
  isProd: process.env.NODE_ENV === "production",
});

export default config;
